import { buildStaffMenu } from "./staffMenu"
// Also available for MKT-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Marketing role menu — cloned from the shared staff (LXO-derived) base.
 *
 * Currently mirrors the staff base exactly. To add MKT-specific
 * overrides without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildMktMenu = () => buildStaffMenu()
